export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "delete_confirm_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm deletion?"])}
    }
  })
}
